import { CombineTypeAnswer } from '../questionBank/questionAdd/types';

import { IGetSurveyInfomation } from 'views/pages/survey/surveyAdd/type';
import { ICheckFileUpload } from 'views/pages/questionBank/components/FileUpload';
import { TTypeUpload } from 'views/pages/questionBank/components/UploadExcel';

export interface IFormInput {
  valueSearch: string;
  valueStatus: string;
}

export interface IList {
  totalPage: number;
  totalItem: number;
  contents: IContent[];
}

export interface IContent {
  orders: number;
  surveyID?: string;
  surveyName?: string;
  startDate?: string;
  endDate?: string;
  status?: number;
  userID?: string;
  userCanViewSurvey?: string[];
  userCanUpdateSurvey?: string[];
}
export interface IRequestSearch {
  surveyID: string;
  surveyName: string;
  startDate: string;
  endDate: string;
  departmentID?: string[];
  surveyType?: number[];
  surveyForm?: number[];
  userID?: string[];
  page?: number;
  pagesize?: number;
  totalPage?: number;
  totalItem?: number;
}

export interface IRequestGetSurveyByID {
  surveyID: string;
  copySurvey: boolean;
}

export interface IFormInputValidate {
  surveyName: string;
}

export interface IDetailSurvey {
  userGroupID?: string;
  userGroupName?: string;
  status?: boolean;
  decentralization?: Decentralization[];
}

export interface Decentralization {
  mucQuanLy?: string;
  dsChucNang?: DsChucNang[];
}

export interface DsChucNang {
  functionGroupID?: number;
  functionIndex?: number;
  chucNang?: string;
  isPhanQuyen?: boolean;
}

export interface IPeopleSurvey {
  customerID: string;
  customerName: string;
  phoneNumber: string;
  email: string;
  sex: boolean;
  staffID: string;
  staffName: string;
  unit: string;
  department: string;
  userName: string;
  checkGroup: 0;
}

export type TSelectType = 'drafting' | 'published' | 'finished' | 'locked';

export const SelectType: { [key in TSelectType]: TSelectType } = {
  drafting: 'drafting',
  published: 'published',
  finished: 'finished',
  locked: 'locked',
};

export const mappingSelectType = {
  drafting: 2,
  published: 1,
  finished: 3,
  locked: 4,
} as Record<string, any>;

export interface EmployeeInfoDisplayed {
  employeeId: boolean;
  name: boolean;
  department: boolean;
  phoneNumber: boolean;
}

const modalTypes = [
  'person-info',
  'adding-questions',
  'adding-questions-user-evaluated',
  'adding-secion',
  'confirm',
  'lock-survey',
  'publish-survey',
  'draft-survey',
  'upload-survey-question',
  'confirm-show-survey-results',
  'delete-question-used-in-survey',
  'warning-exit-edit-survey',
  'upload-evaluate-people-360',
] as const;
type ModalTypesTyple = typeof modalTypes;
export type ModalTypes = ModalTypesTyple[number];

export const inforKeysValuesForEmployee: { [key: string]: string } = {
  employeeId: 'Mã nhân viên',
  name: 'Họ tên',
  department: 'Phòng ban',
  restaurant: 'Nhà hàng',
  phoneNumber: 'Số điện thoại',
};
export const reverseInfoKeysValuesForEmployee: { [key: string]: string } = {
  'Mã nhân viên': 'employeeId',
  'Họ tên': 'name',
  'Phòng ban': 'department',
  'Nhà hàng': 'restaurant',
  'Số điện thoại': 'phoneNumber',
};

export const inforKeysValuesForCustomer: { [key: string]: string } = {
  name: 'Họ tên',
  phoneNumber: 'Số điện thoại',
};
export const reverseInfoKeysValuesForCustomer: { [key: string]: string } = {
  'Họ tên': 'name',
  'Số điện thoại': 'phoneNumber',
};

export const objectSurveyPeopleByNumber: Record<keyof typeof inforKeysValuesForEmployee, string> = {
  employeeId: '1',
  name: '2',
  department: '3',
  restaurant: '4',
  phoneNumber: '5',
};

export interface ISectionGroup {
  [uuid: string]: {
    sectionName: string;
    question: CombineTypeAnswer[];
    title?: string;
  };
}

export interface ISurveyDataSave {
  surveyInformation?: boolean;
  groupQuestions?: boolean;
  surveyMemberList?: boolean;
}

export interface IRouterState {
  selectType: TSelectType;
}
export interface ICopySurveyState {
  copySurvey: boolean;
}

export interface ICheckFileBeforeUpload {
  id: string;
  questionContent: string;
  isvalid: boolean;
  actionType: 'ADD' | 'UPDATE';
  errorMessage: string;
  stt?: string;
}

export interface ICheckFileQuestionBeforeUpload {
  item1: ICheckFileBeforeUpload[];
  item2: any;
}

export interface ICheckFileStaffBeforeUpload {
  id: string;
  // questionContent: string;
  // isvalid: boolean;
  iD_NDDG: string;
  iD_NDG: string;
  type: number;
  errorMessage: string;
  stt?: string;
}

export interface ICheckFileStaffBeforeUploadNormal {
  idStaff: string;
  erroMess: string | null;
  status: boolean;
  stt?: string;
}

export interface ICheckFileUIProps {
  handleUploadExcel: (isAllInValidQuestion?: boolean) => Promise<void>;
  handleCloseCheckModal: () => void;
  handleCheckUploadFile: (
    setDataCallback: (param: ICheckFileUpload) => void,
    file: File
  ) => Promise<void>;
  file: File;
  typeUpload: TTypeUpload;
  isLoadingLayout: boolean;
  setDataFromAPI?: React.Dispatch<any>;
}

export interface IRequestDeleteStaffAssignedBySurvey {
  surveyID: string;
  staffIDAssessor: string;
  staffIDPersonEvaluated: string;
}
